var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE3F3",
    stroke: "#500D76",
    d: "M18 20h8v8h-8zM21 5h8v8h-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h8v8H3V5z",
    fill: "#EDE3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9V5H3v8h8V9zm0 0h10",
    stroke: "#500D76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11 13 7 7",
    stroke: "#500D76",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteDashboard);
export default __webpack_public_path__ + "static/media/siteDashboard.4cd7e8e25ac16919d4e97058930104f2.svg";
export { ForwardRef as ReactComponent };